export const loadingPlaceholder = "·····";

export const notAvailablePlaceholder = "N/A";
